module.exports = __webpack_public_path__ + "img/help_interface.9f15f59b.png";